import { languageForPath } from '@/shared/lib/code-highlight';
import { CodeLines } from '@/shared/ui/code-lines';

import type { ProjectArtifact } from '@mio/shared';

/** Line-numbered, read-only rendering of frozen or authored files; never live IDE content. */
export function ArtifactFileList({
  files,
  kind,
  emptyMessage,
  defaultOpen = false,
}: {
  files: ProjectArtifact['files'];
  /** Accessible prefix for each file, such as "Submitted" or "Reference". */
  kind: string;
  emptyMessage: string;
  /** Show every file's content without a click; used for the reference the learner came to read. */
  defaultOpen?: boolean;
}) {
  if (files.length === 0)
    return (
      <p className="text-fg-muted border-line bg-sidebar rounded-lg border p-4 text-sm">
        {emptyMessage}
      </p>
    );
  return (
    <div className="space-y-2">
      {files.map((file) => (
        <details
          key={file.path}
          open={defaultOpen}
          className="border-line bg-canvas rounded border p-3"
        >
          <summary className="cursor-pointer font-mono text-sm">{file.path}</summary>
          <pre
            className="code-highlight mt-3 overflow-x-auto text-xs leading-5"
            aria-label={`${kind} ${file.path}`}
          >
            <CodeLines code={file.content} language={languageForPath(file.path)} lineNumbers />
          </pre>
        </details>
      ))}
    </div>
  );
}
